import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

export default class ModalEdit extends Component {
  render() {
    // Componente modal de react bootstrap que recibe lo siguiente
    //    handleButtonShow -> función que se encarga de regular cuando se abre y se cierra el modal
    //    toogle           -> variable que contiene el titulo del modal
    //    form             -> Formulario que se mostrará en el cuerpo del modal

    return (
      <Modal {...this.props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered onHide={this.props.handleButtonShow}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{this.props.toogle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.props.form}</Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" onClick={this.props.handleButtonShow} name="Cerrar">
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
